import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  declare readonly inputTarget: HTMLInputElement

  connect (): void {
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  handleSubmitEnd = (): void => {
    this.inputTarget.value = ''
  }
}
